<div [class]="alertClass()" role="alert">
  @if (resolvedIconSrc()) {
    @if (useIconContainer()) {
      <div class="mbm-alert-icon-container" aria-hidden="true">
        <img class="mbm-alert-icon" [src]="resolvedIconSrc()!" alt="" />
      </div>
    } @else {
      <img class="mbm-alert-icon" [src]="resolvedIconSrc()!" alt="" aria-hidden="true" />
    }
  }
  <p class="mbm-alert-text">{{ messageKey() | translate }}</p>
</div>
